<script setup lang="ts">
  import { computed } from 'vue'
  import { toast } from 'vue-sonner'
  import { storeToRefs } from 'pinia'
  import { Dialog, Icon } from '@rapoo/element'
  import { useLocaleStore, useUserStore } from '@/stores'
  import WxQrcode from '@/components/WxQrCode.vue'

  const isOpen = defineModel<boolean>('open', { default: false })
  const userStore = useUserStore()
  const { t } = useLocaleStore()
  const { userInfo } = storeToRefs(userStore)
  const { updateUserInfo } = userStore

  const WEB_SCAN_BIND_REDIRECT_URL = 'https://auth.rapoo.cn/ahubWx/bindRedirect.html'

  const redirectUrl = computed(() => {
    const token = userInfo.value?.token || ''
    return `${WEB_SCAN_BIND_REDIRECT_URL}?token=${token}`
  })

  const handleMessage = (event: MessageEvent) => {
    try {
      const res = JSON.parse(event.data)
      const { data, errorMes } = res || {}

      if (errorMes) {
        toast.error(errorMes)
      }

      if (data) {
        toast.success(t('toast.bindWechatSuccess'))
        updateUserInfo(data)
        isOpen.value = false
      }
    } catch (error) {
      toast.error(t('home.user.bindWechatDialog.error'))
      console.error('Failed to parse message', error)
    }
  }
</script>

<template>
  <Dialog v-model:open="isOpen" :title="$t('home.user.bindWechatDialog.title')" content-class="p-4">
    <div class="flex flex-col items-center gap-4">
      <div class="text-md text-text-glass-default flex gap-[.56rem] items-center">
        <Icon icon="LightEffect-Wireframe-LightFast" class="size-[1.11rem]" />
        {{ $t('home.user.bindWechatDialog.description') }}
      </div>
      <WxQrcode
        :redirect-url="redirectUrl"
        size="11.32rem"
        :handle-iframe-message="handleMessage"
        @scan-login-success="handleMessage"
      />
    </div>
  </Dialog>
</template>

<style lang="scss" scoped></style>
